// extracted by mini-css-extract-plugin
export default {"panel":"GeneralTabPanel_panel__5gvTn","mobile":"GeneralTabPanel_mobile__2ab8J"};